import React from 'react';
import { Input, Select } from 'antd';
import { SelectValue } from "antd/es/select";
import { FieldValues } from "react-hook-form";
import ReadOnly from '../../../../shared/components/dataEntry/ReadOnly';

const { Option } = Select;

interface CustomInputProps{
  className?: string,
  title: string,
  placeholder: string,
  values: FieldValues,
  onChange: any,
  value: any,
  error: any,
  watch: boolean,
}

export default function CustomInput({
  className, title, placeholder, values, onChange, error, value, watch
}: CustomInputProps) {
  return (
    <div className={`${className || ''} flexCol`}>
      <p>{title}</p>
      <div className="inputMarginTop">
        <ReadOnly condition={watch}>
          <Input.Group>
            <Select
              getPopupContainer={(trigger:HTMLElement): any => (trigger.parentElement
                ? trigger.parentElement : null)}
              placeholder={placeholder}
              defaultValue={value}
              disabled={watch}
              onChange={(value: SelectValue) => onChange(value)}
              style={{ width: '100%' }}
            >
              { values?.map(({ valor, descripcion }: any) => (
                <Option key={valor} value={valor}>{descripcion}</Option>
              )) }
            </Select>
          </Input.Group>
        </ReadOnly>
      </div>
      <div>
        {(error && (
          <p className="errors">{error.message}</p>
        ))
        }
      </div>
    </div>
  );
}
